export const SUBSCRIBE_EMAIL_STORAGE_KEY = 'susEmail';
export const SUBSCRIPTION_COMPLETE_PATH = 'suscripcion-completa';
